import React from "react";
import { getFullName } from "../../../careprovider/visits/utils";
import "./patientprofilecard.css";
import { Tag } from "antd";
import { getUserAge } from "../../../../utils/userdatautils";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useGetRole } from "../../../generic/hooks/useGetRole";

const PatientProfileCard = ({ patient, showPatientInfo }) => {
  const role = useGetRole();
  const navigate = useNavigate();
  const patientAge = patient?.birthDate && getUserAge(patient?.birthDate);

  const tagsData = patient?.metadata && JSON.parse(patient?.metadata);
  const tagMapper = {
    maritalStatus: (value) => value && <Tag key="maritalStatus">{value}</Tag>,
  };

  const handleNavigation = () => {
    navigate(
      `${RoleToLinkMapper(role)}patient-profile?identifier=${
        patient?.userIdentifier
      }`,
    );
    window.scrollTo(0, 0);
  };

  return (
    <>
      {patient ? (
        <div className="patient-details-card">
          <div className="patient-details-card-header">
            <span
              className="patient-details-card-primary-title cursor-pointer"
              onClick={handleNavigation}
            >
              {getFullName(patient?.givenName, patient?.familyName)}
            </span>
            <span>(#{patient?.medicalRecordNumber})</span>
          </div>
          {showPatientInfo && (
            <>
              <div className="patient-details-card-header">
                <span>
                  {patient?.gender &&
                    `${patient?.gender?.charAt(0)}${patient?.gender
                      ?.slice(1)
                      .toLowerCase()},`}
                  {patientAge && !isNaN(patientAge) && ` Age ${patientAge}`}
                </span>
              </div>
              <div className="patient-details-card-header">
                {tagsData && (
                  <div className="mt-1">
                    {Object.keys(tagMapper)
                      ?.map((item) => tagMapper[item]?.(tagsData[item]))
                      .filter(Boolean)}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      ) : (
        <span className="patient-details-card-primary-title">Office Work</span>
      )}
    </>
  );
};

export default PatientProfileCard;
